import { render, staticRenderFns } from "./UserGroupDetail.vue?vue&type=template&id=bf9b34d0&scoped=true&"
import script from "./UserGroupDetail.vue?vue&type=script&lang=ts&"
export * from "./UserGroupDetail.vue?vue&type=script&lang=ts&"
import style0 from "./UserGroupDetail.vue?vue&type=style&index=0&id=bf9b34d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf9b34d0",
  null
  
)

export default component.exports